import { useRef, useState } from 'react';
import { Box, Flex } from 'reflexbox';
import styled, { keyframes } from 'styled-components';

import useVoiceMemoRecorder from './useVoiceMemoRecorder';
import VoiceMemoControls from './VoiceMemoControls';
import VoiceMemoWaveForm from './VoiceMemoWaveForm';

const fadeIn = keyframes`
    0% { opacity: 0; transform: scale(1, 0); }
    100% { opacity: 1; transform: scale(1, 1) }
`;

const VoiceMemoActive = styled(Flex)`
	position: relative;
	height: 100%;
	flex-direction: column;
	justify-content: center;
	opacity: 0;
	animation: 0.5s cubic-bezier(0, 1.5, 0.9, 0.9) ${fadeIn};
	animation-delay: 0.5s;
	animation-fill-mode: forwards;
`;

export default function VoiceMemoRecorder(props: {
	stream?: MediaStream;
	onFinish: (blob: Blob, samples: number[], sampleRate: number) => void;
}) {
	const [bars, setBars] = useState<number[]>([]);
	const [current, setCurrent] = useState(0);
	const start = useRef(Date.now()).current;

	const recorder = useVoiceMemoRecorder({
		stream: props.stream,
		sampleRate: 1.0,
		onAmplitude: (amplitude) => setCurrent(amplitude),
		onSample: (amplitude) => setBars((bars) => [...bars, amplitude]),
		onFinish: (blob) => props.onFinish(blob, bars, 1.0),
	});

	return (
		<VoiceMemoActive>
			<Box
				mt={2}
				width="100%"
				height="40px"
				style={{
					position: 'relative',
					overflow: 'hidden',
				}}
			>
				<Box
					style={{
						position: 'absolute',
						left: '50%',
						top: '50%',
						transform: `translate(-${bars.length * 6}px, -50%)`,
						transition: '1s cubic-bezier(0, 1, 0, 1) transform',
					}}
				>
					<VoiceMemoWaveForm recording bars={bars} current={current} />
				</Box>
			</Box>
			<VoiceMemoControls
				status="recording"
				time={Date.now() - start}
				onStop={() => recorder.stop()}
			/>
		</VoiceMemoActive>
	);
}
